<div class="flex-column" style="align-items: center;" [formGroup]="form">
  <span matDialogTitle style="margin-bottom: 2rem;">{{ modalType === FieldModalTypes.Create ? 'Create' : 'Edit' }} Field</span>
  <!-- Name, Visibility -->
  <div class="form-item full-width">
    <ah-asset-field-input
      [group]="form"
      [field]="nameField"
      [fullWidth]="true"
      [required]="true"
      class="full-width"
      (blur)="handleNameInput()"
    ></ah-asset-field-input>
    <div class="flex-column full-width">
      <ah-asset-field-input
        [group]="form"
        [field]="visibilityField"
        [fullWidth]="true"
        [options]="visibilityOptions"
        [required]="true"
        class="full-width"
      ></ah-asset-field-input>
      @if (form.get(visibilityField.canonical_name)?.hasError('required') && form.get(visibilityField.canonical_name)?.touched) {
        <mat-error>
          This field is required
        </mat-error>
      }
    </div>
  </div>
  <!-- Canonical Name, Field Type -->
  <div class="form-item full-width">
    <ah-asset-field-input
      [group]="form"
      [field]="canonicalNameField"
      [fullWidth]="true"
      [required]="true"
      [disabled]="modalType === FieldModalTypes.Edit"
      class="full-width"
      matTooltip="Canonical name should be similar to the name, but all lowercase and underscores instead of spaces."
    ></ah-asset-field-input>
    <div class="flex-column full-width">
      <ah-asset-field-input
        [group]="form"
        [field]="fieldTypeField"
        [fullWidth]="true"
        [options]="fieldTypesOptions"
        [required]="true"
        [disabled]="modalType === FieldModalTypes.Edit"
        class="full-width"
      ></ah-asset-field-input>
      @if (form.get(fieldTypeField.canonical_name)?.hasError('required') && form.get(fieldTypeField.canonical_name)?.touched) {
        <mat-error>
          This field is required
        </mat-error>
      }
    </div>
  </div>
  <!-- Departments, Sort Order -->
  <div class="form-item full-width">
    <div class="full-width multiselect-padding">
      <p-multiSelect #multiSelectRef [autofocusFilter]="true" appendTo="body" [options]="departmentOptions"  [formControlName]="departmentsToAddField.canonical_name" placeholder="Departments to Add to" [maxSelectedLabels]="2" styleClass="multiselect-padding-full-width"  [showClear]="true" [virtualScroll]="true" [virtualScrollItemSize]="30" [panelStyle]="{'--item-count': heightPixel}" (onFilter)="onFilterChange($event)"
      [filter]="true">
       <ng-template pTemplate="header">
          <div class="custom-multiselect-header">
              <button
                  type="button"
                  class="close-button"
                  (click)="multiSelectRef.hide()"
                  aria-label="Close"
              >
                  <i class="pi pi-times"></i>
              </button>
          </div>
      </ng-template>
    </p-multiSelect>
      @if (form.get(departmentsToAddField.canonical_name)?.hasError('required') && form.get(departmentsToAddField.canonical_name)?.touched) {
        <mat-error>
          This field is required
        </mat-error>
      }
    </div>
    <div class="flex-column full-width">
      <ah-asset-field-input
        [group]="form"
        [field]="sortOrderField"
        [fullWidth]="true"
        [required]="true"
        class="full-width"
      ></ah-asset-field-input>
      @if (form.get(sortOrderField.canonical_name)?.hasError('max')) {
        <mat-error>
          This is too big
        </mat-error>
      }
      @if (form.get(sortOrderField.canonical_name)?.hasError('min')) {
        <mat-error>
          This is too small
        </mat-error>
      }
    </div>
  </div>
  <!-- Restricted/Required checkboxes + info -->
  @if (modalType === FieldModalTypes.Create) {
    <div class="flex-column full-width">
      <mat-checkbox ngClass.gt-xs="top-checkbox-margin" formControlName="restricted">Restricted</mat-checkbox>
      <mat-checkbox ngClass.gt-xs="bottom-checkbox-margin" formControlName="required_in_all_depts">Required in all departments</mat-checkbox>
      <div ngClass.gt-xs="info-margin">
        <span>Match fields will be created for this field in all the existing features.</span>
      </div>
    </div>
  }

  <div class="flex gap-20 button-container" style="padding: 8px;">
    @if (saving) {
      <mat-spinner [diameter]="32"></mat-spinner>
    }
    <button mat-raised-button matDialogClose [disabled]="saving" class="cancel-button-padding">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="saving || form.invalid" class="save-button-padding">Save</button>
  </div>
</div>
